<template>
    <div class="container">
        <h3 class="mb-0" v-text="lang('Riassunto richiesta')"></h3>
        <p class="mb-2" v-text="lang('Tipologia richiesta') + ': ' + getType"></p>
        <div class="columns">
            <div class="column is-half">
                <h4 class="is-flex" style="justify-content: space-between; align-items: center">
                    <span v-text="lang('Dati Anagrafici')"></span>
                    <button @click.prevent="edit('registry')"
                            class="button is-primary is-small"
                            v-text="lang('Modifica')"></button>
                </h4>
                <table class="table is-fullwidth is-striped is-bordered">
                    <tr>
                      <th v-text="lang('Tipologia utente')"></th>
                      <td v-text="registry.type === 'azienda' ? lang('Azienda') : lang('Privato')"></td>
                    </tr>
                    <tr v-if="registry.type === 'azienda'">
                        <th v-text="lang('Ragione Sociale')"></th>
                        <td v-text="registry.company"></td>
                    </tr>
                    <tr v-if="registry.type === 'privato'">
                        <th v-text="lang('Nome')"></th>
                        <td v-text="registry.firstname + ' ' + registry.lastname"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Qualifica')"></th>
                        <td v-text="title"></td>
                    </tr>
                    <tr>
                      <th v-text="lang('Richiedente')"></th>
                      <td v-text="buyerType"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Indirizzo email')"></th>
                        <td v-text="registry.email"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Telefono')"></th>
                        <td v-text="registry.phone"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Indirizzo')"></th>
                        <td v-text="registry.address"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Comune')"></th>
                        <td v-text="registry.city"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('C.A.P.')"></th>
                        <td v-text="registry.zip"></td>
                    </tr>
                    <tr v-if="language === 'it'">
                        <th v-text="lang('Provincia')"></th>
                        <td v-text="registryProvince"></td>
                    </tr>
                    <tr v-else>
                        <th v-text="lang('Paese')"></th>
                        <td v-text="registryCountry"></td>
                    </tr>
                </table>
            </div>
            <div class="column is-half">
                <h4 class="is-flex" style="justify-content: space-between; align-items: center">
                    <span v-text="lang('Dati Progetto')"></span>
                    <button @click.prevent="edit('project')"
                            class="button is-primary is-small"
                            v-text="lang('Modifica')"></button>
                </h4>
                <table class="table table is-fullwidth is-striped is-bordered">
                    <tr>
                        <th v-text="lang('Oggetto')"></th>
                        <td v-text="project.subject"></td>
                    </tr>
                    <tr>
                      <th v-text="lang('Stato sviluppo')"></th>
                      <td v-text="developmentStage"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Tipologia')"></th>
                        <td v-text="system"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Superficie (mq)')"></th>
                        <td v-text="project.area"></td>
                    </tr>
                    <tr v-if="language === 'it'">
                        <th v-text="lang('Provincia')"></th>
                        <td v-text="projectProvince"></td>
                    </tr>
                    <tr v-else>
                        <th v-text="lang('Paese')"></th>
                        <td v-text="projectCountry"></td>
                    </tr>
                    <tr>
                        <th v-text="lang('Comune')"></th>
                        <td v-text="project.city"></td>
                    </tr>
                    <tr v-if="type === 'request'">
                        <th v-text="lang('Descrizione')"></th>
                        <td v-text="project.description"></td>
                    </tr>
                </table>
                <div v-if="type === 'request'">
                    <h4 class="is-flex" style="justify-content: space-between; align-items: center">
                        <span>Files</span>
                        <button @click.prevent="edit('upload')"
                                class="button is-primary is-small"
                                v-text="lang('Modifica')"></button>
                    </h4>
                    <table class="table table is-fullwidth is-striped is-bordered">
                        <tr v-for="(value, index) in files" :key="index">
                            <th v-text="index"></th>
                            <td v-text="value.name"></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash'

    export default {
        props: {
            type: {
              type: String,
              required: true
            },
            registry: {
                type: Object,
                required: true
            },
            project: {
                type: Object,
                required: true
            },
            files: {
                type: Array,
                required: false
            },
            provinces: {
                type: Array,
                required: true
            },
            countries: {
                type: Array,
                required: true
            },
            titles: {
                type: Array,
                required: true
            },
            types: {
                type: [Array, Object],
                required: true
            },
            buyersTypes: {
              type: [Array, Object],
              required: true
            },
            developmentStages: {
              type: [Array, Object],
              required: true
            },
            step: {
              type: String,
              required: true
            }
        },
        mounted() {
            if(this.step === 'review') {
              this.$emit('completed');
            }
        },
        methods: {
            edit( step ) {
                this.$emit('edit', step)
            }
        },
        computed: {
            getType() {
                return this.type === 'request' ? this.lang('Richiesta Preventivo') : this.lang('Calcolo Preventivo Online')
            },
            registryProvince() {
                let province = _.find(this.provinces, { id: this.registry.province });
                if( province && province.hasOwnProperty( 'acro' ) ) return province.acro
            },
            projectProvince() {
                let province = _.find(this.provinces, { id: this.project.province });
                if( province && province.hasOwnProperty( 'name' ) ) return province.name
            },
            registryCountry() {
                let country = _.find(this.countries, { id: this.registry.country });
                if( country && country.hasOwnProperty( 'name' ) ) return country.name
            },
            projectCountry() {
                let country = _.find(this.countries, { id: this.project.country });
                if( country && country.hasOwnProperty( 'name' ) ) return country.name
            },
            title() {
                let title = _.find(this.titles, { id: this.registry.title });
                if( title && title.hasOwnProperty( 'name' ) ) return title.name
            },
            system() {
                let type = _.find(this.types, { id: this.project.type });
                if( type && type.hasOwnProperty( 'name' ) ) return type.name
            },
            buyerType() {
              let buyerType = _.find(this.buyersTypes, { id: this.registry.buyer_type });
              if( buyerType && buyerType.hasOwnProperty( 'name' ) ) return buyerType.name
            },
            developmentStage() {
              let developmentStage = _.find(this.developmentStages, { id: this.project.stage_development });
              if( developmentStage && developmentStage.hasOwnProperty( 'name' ) ) return developmentStage.name
            },
            language() {
                return window.language;
            }
        }
    }
</script>